import { ApTemplateStatus } from '../enums/ApTemplateStatus';
import { ApTemplateType } from '../enums/ApTemplateType';
import { validateNumberInput, validateStringInput } from '../utils/formValidationHelpers';
import { ApTemplateAction } from './ApTemplateAction';

export type ApTemplate = {
    templateId: number;
    clientId?: number;
    dateCreated: Date;
    title: string;
    type: ApTemplateType;
    status: ApTemplateStatus;
    actions: ApTemplateAction[];
};

export type GetApTemplateByIdRequest = {
    templateId: number;
};

/**
 * buildGetApTemplateById
 *
 * @description
 * Builds an object which contains as properties the values which, individually, are
 * expected by a request to retrieve an ap template by id
 */
export function buildGetApTemplateById(args: { templateId: number }) {
    return {
        templateId: validateNumberInput('templateId', args.templateId),
    };
}

export type CreateApTemplateRequest = {
    title: string;
    type: ApTemplateType;
};

/**
 * buildCreateApTemplate
 *
 * @description
 * Builds an Ap template object which matches the object expected by the server
 * in a request to create a new Ap template.
 */
export function buildCreateApTemplate(args?: {
    title?: string;
    type?: ApTemplateType;
}): CreateApTemplateRequest {
    return {
        title: args?.title || `New Action Plan - ${new Date().toLocaleDateString()}`,
        type: args?.type || ApTemplateType.instance,
    };
}

export type UpdateApTemplateRequest = {
    title: string;
    type: ApTemplateType;
    status: ApTemplateStatus;
};

/**
 * buildUpdateApTemplate
 *
 * @description
 * Builds an object from an existing Ap template which matches what is expected by the
 * server in a request to update an Ap template.
 */
export function buildUpdateApTemplate(args: {
    title: string;
    type: ApTemplateType;
    status: ApTemplateStatus;
}): UpdateApTemplateRequest {
    return {
        title: validateStringInput('title', args.title),
        type: args.type,
        status: args.status,
    };
}

export interface AssignTemplateAsDraftRequest {
    assignedUser: string;
    contactIds: number[];
}
